import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CiInnoResponsecode extends Component {
    state = {
        CiInnoResponsecodeLists:[],
        CiInnoResponsecodeValue: '',
        isCiInnoResponsecodeLoading: true
    };
    componentDidMount(){
        this.getCiInnoResponsecode(this.props.start_date,this.props.end_date);
    }
    restCiInnoResponsecodeFilter() {
        this.setState({
            CiInnoResponsecodeValue: [],
        })
    }
    getCiInnoResponsecode(start_date, end_date){
        this.setState({
        CiInnoResponsecodeLists:[],
        CiInnoResponsecodeValue: [],
        isCiInnoResponsecodeLoading: true
        })
        axios.get(config.get('API_URL')+'/filters/get_ci_inno_responsecode/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                start_date: start_date,
                end_date: end_date
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((tender_mode, index) => {
                    this.state.CiInnoResponsecodeLists.push({value: tender_mode.ci_inno_responsecode, label: tender_mode.ci_inno_responsecode})
                });
            }
            this.setState({
                isCiInnoResponsecodeLoading: false
            })
        });

    }


    changeCiInnoResponsecode(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.CiInnoResponsecodeLists.findIndex(obj => obj.value==ids.value);
                this.state.CiInnoResponsecodeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectCiInnoResponsecode(optionSelected, tenderArray);
        this.setState({
            CiInnoResponsecodeValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="tender_mode"
                isMulti
                value={this.state.CiInnoResponsecodeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeCiInnoResponsecode.bind(this)}
                options={this.state.CiInnoResponsecodeLists}
                placeholderButtonLabel="Select [Ci Inno Response code]"
                isLoading={this.state.isCiInnoResponsecodeLoading}
            />
        );

    }
}
export default CiInnoResponsecode;